import React, { useEffect, useState } from "react";
import _ from "lodash";

import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import { compose } from "redux";
import { removeUser } from "../shared/utils";
import userImg from "../../assets/images/bingo/user-img.png";
import crossIcon from "../../assets/images/bingo/cross-icon.png";

const BingoUsers = (props) => {
  const users = _.get(props, "gameReducer.roomObj.users");
  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };
  const [allUsers, setAllUsers] = useState([]);
  const comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray?.filter(function (other) {
          return other?.player_id === current?.player_id;
        }).length === 0
      );
    };
  };
  useEffect(() => {
    let { gameReducer } = props;
    let roomObj = _.get(gameReducer, "roomObj");
    if (
      // usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      //   if (roomObj.users.length > allUsers.length) {
      //     let result = roomObj.users.filter(comparer(allUsers));
      //     playAudio(result && result[0].audio_effect ? result[0].audio_effect : "");
      //     setAllUsers(roomObj.users);
      //   }
    }
    if (Object.keys(roomObj).length > 0 && roomObj.users.length < allUsers.length) {
      setAllUsers(roomObj.users);
    }
  }, [props.gameReducer.roomObj]);

  return (
    <>
      <div className="text-center py-2">
        <h2>players</h2>
      </div>
      <div className="players-list">
        {users &&
          users.length > 0 &&
          users.map((user) => (
            <div className="players-wrapper">
              <div className="player-img">
                <img src={user.profile_image} alt="img" />
                <h4 className="username">
                  {user.display_name.length > 20
                    ? `${user.display_name.substring(0, 20)}...`
                    : user.display_name}
                </h4>
              </div>
              <img
                onClick={() => delPlayer(user)}
                src={crossIcon}
                className="cross-icon"
                alt="cross icon"
              />
            </div>
          ))}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withSocket, connect(mapStateToProps, null))(BingoUsers);
